import { styled, SxProps } from '@mui/material'
import icons from '../assets/icons'

export interface Props {
  name: keyof typeof icons
  color?: string
  size?: number
  scale?: number
  sx?: SxProps
}

const iconBaseUrl = 'https://img.icons8.com'
const Img = styled('img')({})

const transforms: Record<string, string> = {
  arrowRightUp: 'rotate(-45deg)',
  back: 'translateX(-4%)',
  forward: 'translateX(4%)',
}

function getIconUrl(name: keyof typeof icons, size: number, color?: string) {
  const path = icons[name]

  if (!path) {
    console.error(`No icon found for name ${name}`)
    return
  }

  const parts = path.split('/')
  const [family, file] = parts

  if (!family || !file || parts.length > 2) {
    console.error(`Icon path in wrong format ${name}. Should be [iconFamily]/[iconName].[iconFormat]`)
    return
  }

  const colorPath = color?.substring(0, 1) === '#' ? color.substring(1) : ''

  const fullPath = [iconBaseUrl, colorPath, family, size, file].filter(Boolean).join('/')
  return fullPath
}

const Icon8 = (props: Props) => {
  const { scale = 2, color, name, size = 30, sx } = props
  const src = getIconUrl(name, size * scale, color)

  return <Img src={src} alt={name} width={size} height={size} sx={{
    ...(transforms[name] && { transform: transforms[name] }),
    ...sx,
  }} />
}

export default Icon8
